<div
  class="overflow-hidden absolute w-6/12 top-2/4 pl-96 ml-48 m-auto text-lg text-gray-400"
>
  PERMISSION DENIED
</div>
